import React from 'react';
import { View } from 'react-native';
import { MoneyBag } from './money-bag';
import { reputationFor, type Profile } from '@ventureroom/core';
import { useData } from './provider';
import { Copy, Row } from './components';

export function MoneyRating({
  person,
  light = false,
  detail = false,
}: {
  person: Profile;
  light?: boolean;
  detail?: boolean;
}) {
  const s = useData();
  const rating = person.reputation ?? reputationFor(s, person);
  return (
    <View
      accessibilityLabel={`${rating.money} out of 5 money rating. ${rating.kind === 'fixed' ? 'Fixed AI capability tier' : rating.kind === 'provisional' ? 'Provisional reputation' : 'Community reputation'}`}
    >
      <Row style={{ gap: 3 }}>
        {[1, 2, 3, 4, 5].map((n) => (
          <MoneyBag key={n} active={n <= rating.money} />
        ))}
        <Copy size={11} color={light ? '#fff' : undefined}>
          {rating.money}/5 ·{' '}
          {rating.kind === 'fixed'
            ? 'AI tier'
            : rating.kind === 'provisional'
              ? 'Provisional'
              : 'Reputation'}
        </Copy>
      </Row>
      {detail && (
        <Copy size={12} muted>
          {rating.kind === 'fixed'
            ? 'Fixed configured specialist tier; not a guarantee of results.'
            : `${rating.score} points · ${rating.upvotes} positive / ${rating.downvotes} negative human reviewers · ${rating.evidenceCount} peer-affirmed reported outcomes. Revenue claims are not audited.`}
        </Copy>
      )}
    </View>
  );
}
